import {Component, OnDestroy, OnInit} from '@angular/core';
import {
    AcabimProject,
    AcabimSite,
    BuildingElement,
    BuildingElementType,
    BuildingSpace,
    BuildingStorey, ProjectApiService, SiteApiService
} from '@cas-hub/acabim-common-client';
import {Subscription} from 'rxjs';
import {BaseLocationModel} from '@cas-hub/acabim-bim-visualiser-client';

@Component({
    selector: 'acabim-admin-user-property-sets',
    templateUrl: './user-property-sets.component.html',
    styleUrls: ['./user-property-sets.component.scss']
})
export class UserPropertySetsComponent implements OnInit, OnDestroy {
    selectedSpace?: BuildingSpace;
    selectedStorey?: BuildingStorey;
    selectedSite?: AcabimSite;
    selectedProject?: AcabimProject;
    showDetailView = false;
    _currentBuildingElement?: { type: BuildingElementType, data: BuildingElement };
    siteSub: Subscription =  new Subscription();
    projectSub: Subscription =  new Subscription();

    constructor(
        private readonly siteApiService: SiteApiService,
        private readonly projectApiService: ProjectApiService
    ) {}

    ngOnInit(): void {
        this.getLocation();
    }

    ngOnDestroy(): void {
        this.siteSub.unsubscribe();
        this.projectSub.unsubscribe();
    }

    setSite($event: AcabimSite) {
        this.selectedSite = $event;
    }

    setProject($event: AcabimProject) {
        this.selectedProject = $event;
    }

    setStorey($event: BuildingStorey) {
        this.selectedStorey = $event;
    }

    setSpace($event: BuildingSpace) {
        this.selectedSpace = $event;
    }

    selectLocation(location: BaseLocationModel): void {
        if (location.site) {
            this.setSite(location.site);
        }
        if (location.project) {
            this.setProject(location.project);
        }
        if (location.storey) {
            this.setStorey(location.storey);
        }
        if (location.space) {
            this.setSpace(location.space);
        }
    }
    showDetails($event: { type: BuildingElementType, data: BuildingElement }) {
        this.showDetailView = true;
        this._currentBuildingElement = $event;
    }

    toggleModal($event: boolean) {
        this.showDetailView = $event;
        if (!$event) {
            this._currentBuildingElement = undefined;
        }
    }

    getLocation(): void {
        this.siteSub = this.siteApiService.selectedSite$.subscribe(site => {
            if (site) {
                this.selectedSite = site;
                this.projectSub = this.projectApiService.selectedProject$.subscribe(project => {
                    if (project) {
                        this.selectedProject = project;
                    } else {
                        this.selectedProject = undefined;
                    }
                });
            } else {
                this.selectedSite = undefined;
            }
        });
    }
}
